import React, { useRef, useState } from "react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Button, Checkbox, Popover, Stack, TextField, Typography } from "@mui/material";
import { Select } from "components/forms";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { CharacteristicDataType } from "store/types";

import { useForm } from ".";

const types = ["Text", "Number", "Percentage", "Currency", "Date"];

export const CreateChar: React.FC = () => {
  const { createChar } = useForm();

  const [type, setType] = useState(types[0]);
  const [isPopupOpen, setIsPopupOpen] = useState<HTMLButtonElement | null>(null);
  const [isGlobal, setIsGlobal] = useState<boolean>(false);
  const [inputError, setInputError] = useState<string>("");

  const inputRef = useRef<HTMLInputElement>(null);

  const resetStates = () => {
    setType(types[0]);
    setIsGlobal(false);
  };

  const handleClose = () => {
    resetStates();
    setIsPopupOpen(null);
  };

  const handleSubmit = () => {
    const { value } = inputRef?.current || {};

    if (!value) {
      setInputError("Name is required");
      return;
    }

    createChar({
      data_type: type.toLowerCase() as CharacteristicDataType,
      is_global: isGlobal,
      name: value,
      is_multiple: false
    });
    handleClose();
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ background: "#f0f0f0", color: "#071F35", maxWidth: "160px", padding: "4px 10px" }}
        onClick={(e) => setIsPopupOpen(e.currentTarget)}
      >
        <AddCircleOutlineIcon />
        <Typography fontSize="12px" sx={{ color: "#071F35" }}>
          Add Characteristic
        </Typography>
      </Button>

      <Popover
        open={!!isPopupOpen}
        anchorEl={isPopupOpen}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        onClose={handleClose}
      >
        <Stack sx={{ padding: "20px", width: "520px" }} justifyContent="space-between">
          <Stack flexDirection="column">
            <Typography mb="20px">Add Characteristic</Typography>
            <Stack flexDirection="column" gap="20px" mb="5px">
              <TextField
                inputRef={inputRef}
                error={Boolean(inputError)}
                helperText={inputError}
                label="Name"
                variant="outlined"
                onChange={() => {
                  if (!setInputError) return;
                  setInputError("");
                }}
              />
              <Select
                label="Type"
                value={type}
                onChange={(e) => setType(e.target.value as string)}
                items={types}
                variant="outlined"
              />
            </Stack>
            <Stack flexDirection="row" alignItems="center" justifyContent="flex-start" gap="5px" mb="10px" ml="-10px">
              <Checkbox
                checkedIcon={<CheckBoxIcon sx={{ fill: "#071F35" }} />}
                checked={isGlobal}
                onChange={() => setIsGlobal(!isGlobal)}
              />
              <Typography color="#0a3142" marginRight="9px">
                Set Global
              </Typography>
              <MaterialTooltip isShow title="Global characteristic will appear in all deal">
                <ErrorOutlineIcon
                  sx={{
                    fill: "#0a3142",
                    "&:hover": {
                      cursor: "pointer"
                    }
                  }}
                />
              </MaterialTooltip>
            </Stack>
            <Stack flexDirection="row" justifyContent="flex-end" alignItems="center" gap="10px">
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <Button
                disabled={Boolean(inputError)}
                sx={{ backgroundColor: "#071F35" }}
                onClick={handleSubmit}
                variant="contained"
              >
                Apply
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Popover>
    </>
  );
};
